import { defineStore } from 'pinia';
import LeadSubmissionsAPI from 'dashboard/api/leadSubmissions';

// Submissions são paginadas server-side (lista pode crescer rápido em contas
// ativas). Mantém current page + meta; mutations atualizam o item em-place.
export const useLeadSubmissionsStore = defineStore('leadSubmissions', {
  state: () => ({
    list: [],
    meta: { current_page: 1, total_count: 0, total_pages: 1 },
    filters: {
      status: null,
      lead_source_id: null,
      q: null,
      page: 1,
      per_page: 50,
    },
    loading: false,
    actingOn: null, // id em ação (convert/discard/reprocess) - pra spinner localizado
    current: null,
  }),
  getters: {
    byId: state => id => state.list.find(s => s.id === Number(id)),
    pendingCount: state =>
      state.list.filter(s => s.status === 'pending_triage').length,
  },
  actions: {
    setFilters(partial) {
      this.filters = { ...this.filters, ...partial };
    },
    async fetch(params = {}) {
      this.loading = true;
      try {
        const query = { ...this.filters, ...params };
        // Limpa null/undefined pra não poluir querystring.
        Object.keys(query).forEach(
          k => (query[k] == null || query[k] === '') && delete query[k]
        );
        const { data } = await LeadSubmissionsAPI.list(query);
        this.list = data.data || data; // jbuilder pode envelopar ou não
        this.meta = data.meta || this.meta;
        return data;
      } finally {
        this.loading = false;
      }
    },
    async fetchOne(id) {
      const { data } = await LeadSubmissionsAPI.show(id);
      this.current = data;
      this.upsert(data);
      return data;
    },
    async convert(id, overrides = {}) {
      this.actingOn = id;
      try {
        const { data } = await LeadSubmissionsAPI.convert(id, overrides);
        // Resposta é o lead criado; remove submission da lista de triage.
        this.list = this.list.filter(s => s.id !== id);
        return data;
      } finally {
        this.actingOn = null;
      }
    },
    async discard(id, reason) {
      this.actingOn = id;
      try {
        const { data } = await LeadSubmissionsAPI.discard(id, reason);
        this.list = this.list.filter(s => s.id !== id);
        return data;
      } finally {
        this.actingOn = null;
      }
    },
    async reprocess(id) {
      this.actingOn = id;
      try {
        const { data } = await LeadSubmissionsAPI.reprocess(id);
        this.upsert(data);
        return data;
      } finally {
        this.actingOn = null;
      }
    },
    upsert(submission) {
      const idx = this.list.findIndex(s => s.id === submission.id);
      if (idx === -1) this.list = [submission, ...this.list];
      else this.list.splice(idx, 1, submission);
    },
  },
});
